document.addEventListener("DOMContentLoaded", function () {
  const actives = document.querySelectorAll(".qa-list__item__active");

  actives.forEach((active) => {
    active.addEventListener("click", () => {
      const itemId = active.dataset.itemId;
      if (active.checked) {
        item_a = document.querySelector("#qa-list__item__a-" + itemId);
        item_a.style.height = item_a.children[0].offsetHeight + "px";
      } else {
        item_a = document.querySelector("#qa-list__item__a-" + itemId);
        item_a.style.height = "";
      }
    });
  });
});
